import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'routing-rule-dialog-advanced-condition',
  templateUrl: './routing-rule-dialog-advanced-condition.component.html',
  styleUrls: ['./routing-rule-dialog-advanced-condition.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class RoutingRuleDialogAdvancedConditionComponent implements OnInit {

  @Input() rule: any;
  @Input() externalData: any;
  @Input() isSipHeaderValid: boolean;
  @Input() isTagValid: boolean;


  useQualityBasedRouting: boolean;
  useTimeBasedRouting: boolean;

  scopeObj: any;

  tagStaticOptions: any = [
    {value: 'TAG_1', label: 'Tag 1'},
    {value: 'TAG_2', label: 'Tag 2'},
    {value: 'TAG_3', label: 'Tag 3'}
  ];

  qualityOptions: any;
  privacyOptions: any;
  timeConditionsOptions: any;
  sipConditionGroups: any;
  tagOptions: any;

  secureLogixOptions: any = {floor: -5, ceil: 5, step: 1};
  defaultMinSecureLogix = 0;
  defaultMaxSecureLogix = 5;

  secureLogixActionDirectiveOptions: any = [{text: 'Allow', value: 'ALLOW'}, {text: 'Block', value: 'BLOCK'}];
  requestTypeOptions = [{label: 'Call', value: 'CALL'}, {label: 'Register', value: 'REGISTER'}];

  constructor() {}

  ngOnInit(): void {
    this.initialize();
  }

  initialize(): void {
    this.scopeObj = {};
    this.useQualityBasedRouting = this.rule.quality !== null;

    this.setSecureLogix();
    this.setQualityOptions();
    this.setPrivacyOptions();
    this.setTagOptions();

    if (this.rule.quality == null) {
      this.scopeObj.quality = {value: 'FAIR', label: 'fair or good paths'};
    } else {
      this.scopeObj.quality = this.qualityOptions.find((option) => {
        return _.isEqual(option.value, this.rule.quality);
      });
    }

    this.scopeObj.privacy = this.privacyOptions.find((option) => {
      return _.isEqual(option.value, this.rule.privacy);
    });

    this.rule.tbrConditionsIds = Array.isArray(this.rule.tbrConditionsIds) ? this.rule.tbrConditionsIds : [];
    this.useTimeBasedRouting = this.rule.tbrConditionsIds.length > 0;

    this.timeConditionsOptions = this.externalData.timeConditions;
    this.sipConditionGroups = this.externalData.sipConditionGroups;
  }

  addSipHeader(): void {
    this.rule.sipHeaders.push({name: '', value: []});
  }

  removeSipHeader(index): void {
    this.rule.sipHeaders.splice(index, 1);
  }

  addTag(): void {
    this.updateTags();
    this.rule.tags.push({name: '', value: []});
  }

  removeTag(index): void {
    this.rule.tags.splice(index, 1);
  }

  updateTags(): void {
    if (this.rule.tags.length > 0) {
      const selectedTags = this.rule.tags.map(t => t.tag);
      this.tagOptions =  this.tagStaticOptions.filter(t => selectedTags.indexOf(t.value) === -1);
    }
  }

  setQualityOptions(): void {
    this.qualityOptions = [
      {value: 'FAIR', label: 'fair or good paths'},
      {value: 'GOOD', label: 'good paths'}
    ];
  }

  setTagOptions(): void {
    this.tagOptions = _.clone(this.tagStaticOptions);
  }

  setPrivacyOptions(): void {
    this.privacyOptions = [
      {value: 'TRANSPARENT', label: 'Transparent'},
      {value: 'TRANSPARENT_WITH_PRIVACY_ID', label: 'Transparent with privacy id'},
      {value: 'ANONYMOUS_CALLER', label: 'Anonymous caller'},
      {value: 'IDENTIFY_CALLER', label: 'Identify caller'}
    ];
  }

  setSecureLogix(): void {
    this.rule.isSecureLogixEnabled = this.rule.minSecureLogix !== null && this.rule.maxSecureLogix !== null;
    this.secureLogixChanged();

    if (_.isNil(this.rule.minSecureLogix)) {
      this.rule.minSecureLogix = this.defaultMinSecureLogix;
    }

    if (_.isNil(this.rule.maxSecureLogix)) {
      this.rule.maxSecureLogix = this.defaultMaxSecureLogix;
    }
  }

  secureLogixChanged(): void {
    this.secureLogixOptions = Object.assign({}, this.secureLogixOptions, {disabled: !this.rule.isSecureLogixEnabled});
  }
}
